export const saveFacebookLoggedIn = loggedIn => {
  localStorage.setItem('loggedIn', loggedIn)
}

export const getFacebookLoggedIn = () => {
  return localStorage.getItem('loggedIn')
}
